import { Form } from "react-bootstrap";
import { CrudCustomPlaceholderInputModel } from "./crudCustomInputModel";

export function CrudCustomPlaceholderInput({
  component,
  props,
}: CrudCustomPlaceholderInputModel) {
  if (props === undefined) return null;

  const { validationSchema, form, name, label, disabled, t } = props;

  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        return (
          <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>
            {component({
              id: field.name,
              name: field.name,
              value: field.state.value,
              onBlur: field.handleBlur,
              onChange: (e) => {
                field.handleChange(e.target.value);
              },
              isInvalid: field.state.meta.errors.length > 0,
              disabled: disabled,
            })}
            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
}
